<ngb-alert *ngFor="let alert of alerts; let i = index"
           [type]="alert.type"
           (closed)="closeAlert(i)">
    {{ alert.msg }}
</ngb-alert>